import { Controller } from "@hotwired/stimulus"

// Manages the report signatures form
// Tracks completion status and enables/disables the finalize button
export default class extends Controller {
  static targets = ["form", "signatureCard", "signatureInput", "finalizeButton"]

  connect() {
    this.updateFinalizeButton()

    // Listen for changes to signature inputs
    this.signatureInputTargets.forEach((input) => {
      input.addEventListener("change", () => this.updateFinalizeButton())
    })
  }

  updateFinalizeButton() {
    // Check if all signature inputs have values
    const allSigned = this.signatureInputTargets.every((input) => {
      // Skip if this card already has a signed signature (shown as image)
      const card = input.closest('[data-report-signatures-target="signatureCard"]')
      if (card && card.querySelector("img")) {
        return true // Already signed
      }
      return input.value && input.value.length > 0
    })

    if (this.hasFinalizeButtonTarget) {
      this.finalizeButtonTarget.disabled = !allSigned
    }
  }
}
